import _extends from "@babel/runtime/helpers/extends";
import { Button, Input, Modal, Text } from '@carnica/ui-kit';
import React from 'react';
import classNames from 'classnames/bind';
import { EZIndices } from "../../../../../../components/constants";
import withEnterKeyHandler from "../../../../../../utils/withOnEnterKeyHandler";
import { getPortalContainer } from "../../../../../../utils/window";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var EnhancedInput = withEnterKeyHandler(Input);
export var EmailPopup = function EmailPopup(_ref) {
  var onClose = _ref.onClose,
    title = _ref.title,
    buttonProps = _ref.buttonProps,
    inputProps = _ref.inputProps;
  return /*#__PURE__*/React.createElement(Modal, {
    className: cn('wrapper'),
    closeOptions: {
      button: true,
      escape: true,
      overlay: false
    },
    isOpen: true,
    nonce: "",
    onClose: onClose,
    portalProps: {
      style: {
        zIndex: EZIndices.Overlay
      },
      // @ts-expect-error uikit doesn't export this
      container: getPortalContainer()
    },
    size: "s",
    "data-t-id": "Popups-EmailPopup"
  }, /*#__PURE__*/React.createElement(Text, {
    tagName: "h2",
    variant: "body-large",
    "data-t-id": "Popups-EmailPopup"
  }, title), /*#__PURE__*/React.createElement(EnhancedInput, _extends({}, inputProps, {
    maxLength: 254,
    type: "email"
  })), /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
    size: "l",
    width: "full"
  })));
};